import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $on = _ref.$on,
      $update = _ref.$update;

  /*
   * Inizializza variabili
   */
  var user = {
    data: {
      calendar: []
    }
  };
  var calendar = [];
  var ALL_ITEMS = false;
  var TS_LIMIT = Date.now() - 3600000 * myApp.calendar_hours_limit;
  /*
   * Visualizza gli items attivi oppure scaduti da meno TS_LIMIT.
   */

  var viewActives = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return myApp.user();

            case 2:
              user = _context.sent;
              // -> calendario condiviso tra user e childrens
              user.data.calendar = user.data.calendar || [];
              calendar = user.data.calendar.filter(function (e) {
                return e.ts * 1000 >= TS_LIMIT;
              });
              $update();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function viewActives() {
      return _ref2.apply(this, arguments);
    };
  }();
  /*
   * Visualizza tutti gli items, anche quelli scaduti
   */


  var viewAll = function viewAll() {
    calendar = user.data.calendar.map(function (e) {
      if (e.ts * 1000 < TS_LIMIT) {
        e.color = 'text-color-red';
      }

      return e;
    });
    $update();
  };
  /*
   * Alterna visualizzazione predefinita / tutti gli items
   */


  var toggleView = function toggleView() {
    ALL_ITEMS = !ALL_ITEMS;
    ALL_ITEMS ? viewAll() : viewActives();
  };
  /*
   * Page events
   * https://framework7.io/docs/router-component.html#component-page-events
   */


  $on('pageBeforeIn', function () {
    viewActives();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="calendar-list">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">${lng.calendar_list_title}</div>
        <div class="right">
          <a href="/calendar/_new/" class="link icon-only navbar-tooltip">
            <i class="icon f7-icons if-not-md">plus</i>
            <i class="icon material-icons if-md">add</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white hide-navbar-on-scroll unselectable">

      ${(calendar.length > 0) ? $h`
      <div class="bg-color-black text-color-white text-align-center padding-horizontal padding-vertical-half">
        ${lng.calendar_list_plus_message}
      </div>
      <div class="list mt-0">
        <ul>
          ${calendar.map((item) => $h`
          <a href="/calendar/${item.id}/" class="item-link item-content">
            <div class="item-media"><i class="f7-icons ${item.color}">calendar_today</i></div>
            <div class="item-inner">
              <div class="item-title">
                <div class="item-header">${new Date(item.ts * 1000).toLocaleString()}</div>${item.caption}
              </div>
              <div class="item-after">${item.type}</div>
            </div>
          </a>
          `)}
        </ul>
      </div>
      ` : $h`
      <div class="display-flex flex-direction-column justify-content-center align-items-center h-90">
        <img width="150" src="static/notfound.svg"/>

        <div class="block text-align-center">
          <h3>${lng.calendar_list_empty_message}</h3>
          <p>${lng.calendar_list_plus_message}</p>
        </div>
      </div>
      `}

    </div>
  </div>
`
    }
    ;
});